
<ngx-extended-pdf-viewer 
[enablePrint]="false"
[showToolbar]="false"
[enableDragAndDrop]="false"
[handTool]="false"
[src]="fileSrc">
</ngx-extended-pdf-viewer>